var React = require('react');

function YellowListShape (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#EDD767","fillRule":"nonzero"},React.createElement("path",{"d":"M827.863 2858.758c4.183-6.039 9.47-11.534 14.25-17.12 2.921-3.413 16.08-14.693 21.43-12.31 4.9 2.183 11.36 1.207 16.63 3.051 13.267 4.641 21.126 16.455 32.309 23.758 5.632 3.68 10.397 7.718 15.68 11.954 5.908 4.735 9.934 11.443 14.138 17.62 9.284 13.647-7.945 26.964-13.04 38.764-3.958 9.166-18.492 19.525-28.207 19.525-8.277 0-16.54-.548-24.763-.646-14.749-.179-28.326-2.779-42.42-6.46-6.968-1.821-9.465-7.136-12.088-12.92-2.395-5.28-2.598-11.659-4.469-17.157-2.808-8.251-2.272-17.502-2.272-26.129 0-8.183 8.468-15.644 12.822-21.93z","transform":"translate(-815 -2829)"}))));
}

YellowListShape.defaultProps = {"width":"130","height":"115","viewBox":"0 0 130 115"};

module.exports = YellowListShape;

YellowListShape.default = YellowListShape;
